import script from "./RedeemPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemPage.vue?vue&type=script&setup=true&lang=js"

import "./RedeemPage.vue?vue&type=style&index=0&id=58ba392e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ba392e"]])

export default __exports__